
export default {
  name: 'AtomContentSliderBrochure',
  props: {}
}
